(function () {
	'use strict';

	angular
		.module('directives')
		.directive('onKeyCode', onKeyCode);

	function onKeyCode() {
		var directive = {
			restrict: 'A',
			link: link
		};

		return directive;

		function link($scope, $element, $attrs) {
			$element.bind('keypress', function (event) {
				var keyCode = event.which || event.keyCode;

				if (keyCode == $attrs.code) {
					$scope.$apply(function () {
						$scope.$eval($attrs.onKeyCode, {
							$event: event
						});
					});

				}
			});
		}
	}
})();
